const isReturningUserDataAvailable = require("../returningUser/isReturningUserDataAvailable");
const showAllWhitepaper2024ReturningUserContainersOnThePage = require("./showAllWhitepaper2024ReturningUserContainersOnThePage");
const hideAllWhitepaper2024ReturningUserContainersOnThePage = require("./hideAllWhitepaper2024ReturningUserContainersOnThePage");
const showFormFieldsForAllWhitepaper2024Forms = require("./showFormFieldsForAllWhitepaper2024Forms");

/**
 * @return {void}
 */
module.exports = function initWhitepaper2024ReturningUserVisibility() {
    if (isReturningUserDataAvailable()) {
        showAllWhitepaper2024ReturningUserContainersOnThePage();
    } else {
        hideAllWhitepaper2024ReturningUserContainersOnThePage();
        showFormFieldsForAllWhitepaper2024Forms();
    }
}
